<template>
		<button
			class="AIButton"
			@click="getAIAssistant()"
			@keydown.enter="getAIAssistant()"
			tabindex=0
		>AI助教</button>
</template>

<script>
	export  default {
		methods: {
			getAIAssistant(){
				this.$router.push({"name": "AIAssistant"});
			}
		}
	}
</script>

<style>
.AIButton {
	justify-content: center;
	background: linear-gradient(to bottom, rgb(0, 180, 0), rgb(0, 255, 0));
	border: none;
	border-radius: 10%;
	cursor: pointer;
}
</style>